import { faMagicWandSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type ReactNode } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';

import { cn } from '../lib/utils';

const betaBadgeVariants = tv({
  slots: {
    root: 'font-bold',
    icon: 'shrink-0'
  },
  variants: {
    variant: {
      pill: {
        root: 'inline-flex items-center gap-1 rounded-full bg-yellow-100 px-2 py-0.5 text-xs text-yellow-900 dark:bg-yellow-900 dark:text-yellow-200',
        icon: 'h-3 w-3 text-yellow-600 dark:text-yellow-300'
      },
      superscript: {
        icon: 'mr-0.5 text-yellow-500'
      }
    }
  },
  defaultVariants: { variant: 'pill' }
});

type BetaBadgeVariants = VariantProps<typeof betaBadgeVariants>;

interface BetaBadgeProps {
  /** `superscript` sits after a label, the way menu items have marked betas. */
  variant?: 'pill' | 'superscript';
  children?: ReactNode;
  className?: string;
}

function BetaBadge({ variant = 'pill', children = 'BETA', className }: BetaBadgeProps) {
  const { root, icon } = betaBadgeVariants({ variant });
  const Element = variant === 'superscript' ? 'sup' : 'span';

  return (
    <Element className={cn(root(), className)}>
      <FontAwesomeIcon icon={faMagicWandSparkles} className={icon()} />
      {children}
    </Element>
  );
}

export { BetaBadge, betaBadgeVariants };
export type { BetaBadgeProps, BetaBadgeVariants };
